import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API, useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/', { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const res = await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
        setUser(res.data.user);
        const stored = sessionStorage.getItem('post_login_next');
        sessionStorage.removeItem('post_login_next');
        const dest = stored && stored.startsWith('/') && !stored.startsWith('/login') ? stored : '/';
        window.history.replaceState({}, '', dest);
        navigate(dest, { replace: true, state: { user: res.data.user } });
      } catch (e) {
        console.error('Auth failed', e);
        sessionStorage.removeItem('post_login_next');
        navigate('/login', { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-3 text-sm text-gray-600">ଲଗଇନ ପ୍ରକ୍ରିୟା ଚାଲିଛି...</p>
      </div>
    </div>
  );
}
